<template>
    <iom-form></iom-form>
</template>

<script>
import IomForm from "@/views/pages/dashboard/iom/IomForm";

export default {
    name: "new",
    components: {
        IomForm,
    },
}
</script>
